export const recoveryMessages = {
  PASSWORD_RESTRICT: 'Пароль должен состоять из 6-30 символов и содержать цифру, строчную и заглавную буквы!'
}
